import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Chip from '@mui/material/Chip';
import { Translate, openFile, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './driver.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

const BooleanDisplay = ({ value }: { value?: boolean }) =>
  value ? (
    <Chip icon={<FontAwesomeIcon icon="check" />} label="Yes" color="success" size="small" />
  ) : (
    <Chip icon={<FontAwesomeIcon icon="times" />} label="No" color="error" size="small" />
  );

export const DriverDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const driverEntity = useAppSelector(state => state.driver.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="driverDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.driver.detail.title">Driver</Translate>
        </h2>
        {driverEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {driverEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.name" />
          </FieldLabel>
          <FieldValue>{driverEntity.name}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.enabled" />
          </FieldLabel>
          <BooleanDisplay value={driverEntity.enabled} />

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.hiredAt" />
          </FieldLabel>
          <FieldValue>
            {driverEntity.hiredAt ? <TextFormat value={driverEntity.hiredAt} type="date" format={APP_LOCAL_DATE_FORMAT} /> : null}
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.age" />
          </FieldLabel>
          <FieldValue>{driverEntity.age}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.email" />
          </FieldLabel>
          <FieldValue>{driverEntity.email}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.mobile" />
          </FieldLabel>
          <FieldValue>{driverEntity.mobile}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.createdDate" />
          </FieldLabel>
          <FieldValue>
            {driverEntity.createdDate ? <TextFormat value={driverEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} /> : null}
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.defaultImage" />
          </FieldLabel>
          <FieldValue>{driverEntity.defaultImage}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.driver.defaultImageData" />
          </FieldLabel>
          {driverEntity.defaultImageData ? (
            <Box sx={{ mb: 2 }}>
              {driverEntity.defaultImageDataContentType ? (
                <a onClick={openFile(driverEntity.defaultImageDataContentType, driverEntity.defaultImageData)}>
                  <img
                    src={`data:${driverEntity.defaultImageDataContentType};base64,${driverEntity.defaultImageData}`}
                    style={{ maxHeight: '30px' }}
                  />
                </a>
              ) : null}
              <Typography variant="body2" color="text.secondary">
                {driverEntity.defaultImageDataContentType}, {byteSize(driverEntity.defaultImageData)}
              </Typography>
            </Box>
          ) : (
            <FieldValue>No image</FieldValue>
          )}
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button component={Link} to="/driver" replace color="info" variant="outlined" startIcon={<FontAwesomeIcon icon="arrow-left" />}>
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/driver/${driverEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DriverDetail;
